import { NativeSelect } from '@linktr.ee/arbor/components/NativeSelect';
import { useId, type SelectHTMLAttributes } from 'react';

type InputSelectOption = {
  text: string;
  value: string;
};

export type InputSelectProps = Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  'children' | 'size'
> & {
  label: string;
  options: InputSelectOption[];
  state?: 'disabled' | 'default' | 'error';
};

const InputSelect = ({
  label,
  options,
  id,
  disabled,
  state = 'default',
  ...props
}: InputSelectProps) => {
  const generatedId = useId();
  const selectId = id ?? generatedId;
  const resolvedState = disabled || state === 'disabled' ? 'disabled' : state;

  return (
    <div className="flex w-full flex-col gap-1">
      <label
        htmlFor={selectId}
        className="text-body-small-regular text-secondary"
      >
        {label}
      </label>
      <NativeSelect
        {...props}
        id={selectId}
        disabled={disabled}
        state={resolvedState}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </NativeSelect>
    </div>
  );
};

export default InputSelect;
